import React from "react";
import "./skills.css";

import { BsFillPatchCheckFill } from "react-icons/bs";

const Skills = () => {
  return (
    <section id="skills">
      <h2>
        My Skills <span className="dot">.</span>{" "}
      </h2>

      <div className="container skills__container">
        <div className="skills__frontend">
          <div className="skills__content">
            <article className="skills__details">
              <span>
                <BsFillPatchCheckFill className="skills__details-icon" />
              </span>
              <div>
                <h4>React.js</h4>
                <small className="text-dark-light">Experienced</small>
              </div>
            </article>
            <article className="skills__details">
              <span>
                <BsFillPatchCheckFill className="skills__details-icon" />
              </span>
              <div>
                <h4>JavaScript (ES6+)</h4>
                <small className="text-dark-light">Experienced</small>
              </div>
            </article>
            <article className="skills__details">
              <span>
                {" "}
                <BsFillPatchCheckFill className="skills__details-icon" />
              </span>
              <div>
                <h4>Redux & Redu Tooltkit</h4>
                <small className="text-dark-light">Experienced</small>
              </div>
            </article>
            <article className="skills__details">
              <span>
                {" "}
                <BsFillPatchCheckFill className="skills__details-icon" />
              </span>
              <div>
                <h4>HTML & CSS</h4>
                <small className="text-dark-light">Experienced</small>
              </div>
            </article>
            <article className="skills__details">
              <span>
                {" "}
                <BsFillPatchCheckFill className="skills__details-icon" />
              </span>
              <div>
                <h4>React Router</h4>
                <small className="text-dark-light">Experienced</small>
              </div>
            </article>
            <article className="skills__details">
              <span>
                {" "}
                <BsFillPatchCheckFill className="skills__details-icon" />
              </span>
              <div>
                <h4>Formik & Yup</h4>
                <small className="text-dark-light">Experienced</small>
              </div>
            </article>
            <article className="skills__details">
              <span>
                {" "}
                <BsFillPatchCheckFill className="skills__details-icon" />
              </span>
              <div>
                <h4>Material-UI</h4>
                <small className="text-dark-light">Experienced</small>
              </div>
            </article>
            <article className="skills__details">
              <span>
                {" "}
                <BsFillPatchCheckFill className="skills__details-icon" />
              </span>
              <div>
                <h4>Babel & Webpack</h4>
                <small className="text-dark-light">Intermediate</small>
              </div>
            </article>
            <article className="skills__details">
              <span>
                {" "}
                <BsFillPatchCheckFill className="skills__details-icon" />
              </span>
              <div>
                <h4>Node.js</h4>
                <small className="text-dark-light">Experienced</small>
              </div>
            </article>
            <article className="skills__details">
              <span>
                {" "}
                <BsFillPatchCheckFill className="skills__details-icon" />
              </span>
              <div>
                <h4>SQL & NoSQL Databases</h4>
                <small className="text-dark-light">Experienced</small>{" "}
              </div>
            </article>
            <article className="skills__details">
              <span>
                {" "}
                <BsFillPatchCheckFill className="skills__details-icon" />
              </span>
              <div>
                <h4>RESTful APIs</h4>
                <small className="text-dark-light">Experienced</small>{" "}
              </div>
            </article>
            <article className="skills__details">
              <span>
                {" "}
                <BsFillPatchCheckFill className="skills__details-icon" />
              </span>
              <div>
                <h4>UI/UX Design Principles</h4>
                <small className="text-dark-light">Intermediate</small>{" "}
              </div>
            </article>
            <article className="skills__details">
              <span>
                {" "}
                <BsFillPatchCheckFill className="skills__details-icon" />
              </span>
              <div>
                <h4>Git & Version Control</h4>
                <small className="text-dark-light">Experienced</small>{" "}
              </div>
            </article>
          </div>
        </div>
        <span
          style={{
            display: "flex",

            justifyContent: "center",
          }}
        >
          <lord-icon
            class="u-hide:s u-hide:m"
            src="https://cdn.lordicon.com/pbihtexz.json"
            trigger="morph"
            stroke="light"
            state="morph-open"
            colors="primary:#6000cb,secondary:#e4e4e4,tertiary:#848484,quaternary:#d1f3fa"
            style={{ width: "350px", height: "350px" }}
          ></lord-icon>
        </span>
      </div>
    </section>
  );
};

export default Skills;
